var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-authorized"},[_c('h1',[_vm._v("You are not authorized to perform this operation.")]),_c('router-link',{staticClass:"button-gemnote button-gemnote--medium",attrs:{"to":"/report","tag":"button"}},[_vm._v("Back to home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }